<template>
    <div class="GetAQuoteForm">
        <div class="container-block">
            <div class="form">
                <div class="wrap">
                    <form ref="vform" @submit.prevent="submit" class="contact-information">
                        <input :type="formtype" hidden>

                        <div v-if="$store.state.contactInformationActive">
                            <div class="field-item" v-for="itemChildren in forms.contacts"
                                 v-if="itemChildren.type === 'title'">
                                <h3 class="form__title">{{ itemChildren.title }}</h3>
                            </div>

                            <fields :items="forms['contacts'].schema"
                                    @returnStatusToParent="statusParentHandler"
                                    :array="$store.state.contactInformation"></fields>

                            <div class="select-specification">
                                <div class="select-specification--item">
                                    <div class="select-specification--title">Submit specification file</div>
                                    <p>If you already have a complete specification document or drawing you may send it
                                        to us rather than complete the specification details.</p>
                                    <div class="upload-file">
                                        <label for="upload">
                                            <input type="file" @change="onFileChange" value="" id="upload">
                                            <span class="button">Add file</span>
                                        </label>
                                        <div class="name" v-html="fileName ? fileName : 'No file chosen'"></div>
                                    </div>
                                    <div class="button-wrap">
                                        <button type="submit" class="btn"
                                                :class="{'disable': $store.state.submitStatus === 'PENDING'}">Submit
                                            specification
                                        </button>
                                    </div>
                                </div>

                                <div class="separate"><span>or</span></div>

                                <div class="select-specification--item">
                                    <div class="select-specification--title">Enter Specifications</div>
                                    <p>Select pallet type to begin entering of the pallet configuration desired.</p>

                                    <div class="select-block">
                                        <div class="select-block--item">
                                            <div class="info">
                                                <div class="image"><img src="/images/schemes/scheme.png" alt=""></div>
                                                <div class="name">Block pallet</div>
                                            </div>
                                            <div class="btn" @click="blockPalletShow()">Select</div>
                                        </div>

                                        <div class="select-block--item">
                                            <div class="info">
                                                <div class="image"><img src="/images/schemes/scheme2.png" alt=""></div>
                                                <div class="name">stringer pallet</div>
                                            </div>
                                            <div class="btn" @click="stringerPalletShow()">Select</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="info-text"
                                 v-if="$store.state.submitStatus === 'ERROR' || $store.state.submitStatus === 'OK' || $store.state.submitStatus === 'PENDING'">
                                <div class="success" v-if="$store.state.submitStatus === 'OK'">
                                    <div class="icon-cross close" @click="$store.state.submitStatus = null"></div>
                                    Thanks for your submission!
                                </div>
                                <div class="error-wrap" v-if="$store.state.submitStatus === 'ERROR'">
                                    <div class="icon-cross close" @click="$store.state.submitStatus = null"></div>
                                    Some required fields are missing. Please fix them.
                                </div>
                                <div class="typo__p" v-if="$store.state.submitStatus === 'PENDING'">Sending...</div>
                            </div>

                            <div class="contact-block">
                                <div class="title">Or get help</div>
                                <p>Simply click below and we will be in touch shortly to help develop the optimal
                                    solution for your application!</p>
                                <div class="button-wrap">
                                    <span class="btn" @click="openModalContact()">Help Please</span>
                                </div>
                            </div>
                        </div>

                        <block-pallet :actions="actionprops"
                                      :recapthcakeyprops="recapthcakey"
                                      :formtypeprops="formtype"
                                      :formsItem="forms['block-pallet'].schema"
                                      :form_id="forms['block-pallet'].form_id"
                                      @submit="submit"
                                      v-if="$store.state.blockPalletActive">
                        </block-pallet>
                        <stringer-pallet :actions="actionprops"
                                         :formtypeprops="formtype"
                                         @submit="submit"
                                         :recapthcakeyprops="recapthcakey"
                                         :formsItem="forms['stringer-pallet'].schema"
                                         :form_id="forms['stringer-pallet'].form_id"
                                         v-if="$store.state.stringerPalletActive">
                        </stringer-pallet>
                    </form>

                    <vue-recaptcha :sitekey="recapthcakey"
                                   data-badge="inline"
                                   ref="recaptcha"
                                   size="invisible"
                                   @verify="onVerify"></vue-recaptcha>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import fields from "./fields.vue";
import Vue from 'vue'
import Vuex from 'vuex';
import Vuelidate from 'vuelidate'
import {required, email} from 'vuelidate/lib/validators'
import VueRecaptcha from 'vue-recaptcha';
import VueScrollTo from 'vue-scrollto'
import VueMask from 'v-mask'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component("v-select", vSelect);

Vue.use(VueMask);
Vue.use(Vuelidate);
Vue.use(VueScrollTo);

export default {
    name: 'GetAQuote',
    components: {
        'vue-recaptcha': VueRecaptcha,
        fields,
    },
    props: [
        'formtype',
        'recapthcakey',
        'actionprops',
        'forms',
        'form_id'
    ],
    data() {
        return {
            captcha: '',
            childHasError: true,
            fileName: '',
            file: [],
        }
    },
    validations() {

    },
    methods: {
        openModalContact() {
            this.$store.state.contactModalActive = true
            this.$store.state.noscrollActive = true
        },
        onFileChange(el) {
            // eslint-disable-next-line no-unused-vars
            const files = el.target.files || el.dataTransfer.files
            // eslint-disable-next-line prefer-destructuring
            this.fileName = document.getElementById('upload').files[0].name
            this.file.push(document.getElementById('upload').files[0])
        },
        submit() {
            console.log('GetAQuote submit start. State:', this.$store.state)
            this.$eventPool.$emit("touchChildForm")

            this.$nextTick(() => {
                if (this.childHasError) {
                    this.$refs.recaptcha.execute();
                } else {
                    this.$store.state.submitStatus = 'ERROR';
                    this.childHasError = true;
                    setTimeout(() => {
                        VueScrollTo.scrollTo('.error', 300);
                    }, 200);
                }
            })
        },
        onVerify: function (response) {
            console.log('GetAQuote onVerify start. State:', this.$store.state)
            this.$store.state.submitStatus = 'PENDING';

            let formData = new FormData();
            formData.append('g-recaptcha-response', response);
            formData.append('form_type', 'get-a-quote');
            formData.append('form_id', this.form_id);

            if (this.file[0]) {
                formData.append('file', this.file[0]);
            }

            const currentForm = this.$store.state.currentForm
            Object.keys(currentForm).forEach((item) => {
                if (typeof currentForm[item] === 'object') {
                    formData.append(item, JSON.stringify(currentForm[item]))
                } else {
                    formData.append(item, currentForm[item])
                }
            })

            axios.post(this.actionprops, formData)
                .then(response => {
                    console.log('message', response);

                    if (response.data.result === 'ok') {
                        this.$store.state.submitStatus = 'OK';

                        formData = new FormData();
                        this.childHasError = true;
                        this.$store.state.currentForm = {};
                        this.$refs.vform.reset();
                        this.$eventPool.$emit("resetChildForm");
                    }

                    if (response.data.result === 'error') {
                        this.$store.state.submitStatus = 'ERROR';
                    }

                    this.$refs.recaptcha.reset();
                })
                .catch(error => {
                    console.log(error)
                    this.$refs.recaptcha.reset();
                });

        },
        status(validation) {
            return {
                error: validation.$error,
                dirty: validation.$dirty
            }
        },
        blockPalletShow() {
            this.childHasError = true
            this.$eventPool.$emit("touchChildForm")

            this.$nextTick(() => {
                if (this.childHasError) {
                    this.$store.state.blockPalletActive = true
                    this.$store.state.stringerPalletActive = false
                    this.$store.state.contactInformationActive = false
                } else {
                    this.$store.state.submitStatus = 'ERROR';
                    if (document.getElementsByClassName('error').length > 0) {
                        setTimeout(() => {
                            VueScrollTo.scrollTo('.error', 300);
                        }, 200);
                    }
                }
            })
        },
        stringerPalletShow() {
            this.childHasError = true
            this.$eventPool.$emit("touchChildForm")

            this.$nextTick(() => {
                if (this.childHasError) {
                    this.$store.state.blockPalletActive = false
                    this.$store.state.stringerPalletActive = true
                    this.$store.state.contactInformationActive = false
                } else {
                    this.$store.state.submitStatus = 'ERROR';
                    setTimeout(() => {
                        VueScrollTo.scrollTo('.error', 300);
                    }, 200);
                }
            })
        },
        statusParentHandler(isValid) {
            console.log('childHasError', this.childHasError, isValid)
            this.childHasError = this.childHasError && isValid
        },
    },
    mounted() {

    },
}
</script>
